var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full",class:[_vm.color && ("bg-" + _vm.color), ("h-" + _vm.size + " w-" + _vm.size)],style:({ background: _vm.explicitColor })})}
var staticRenderFns = []

export { render, staticRenderFns }